import Skeleton from "@/components/common/Skeleton";
import { useUserStore } from "@/modules/auth/store/user";
import { useTranslation } from "react-i18next";

const RankProgress = () => {
  const { t } = useTranslation();

  const { matchingBonus, isMatchingBonusLoading } = useUserStore();

  const progress = matchingBonus.rank.next.progress;

  return (
    <>
      <div className="w-full flex flex-col items-center bg-bg rounded-[0.75rem]">
        <div className="w-full flex flex-col p-4 gap-3">
          <p className="text-[0.9375rem] leading-[1.25rem] text-subtitle-text">
            <span className="font-semibold">{t("bonus-page.rank")}:</span>{" "}
            {isMatchingBonusLoading ? (
              <Skeleton className="inline-block align-middle w-10 h-4.5" />
            ) : (
              <span className="uppercase">
                {matchingBonus.rank.current.title}
              </span>
            )}
          </p>
          <p className="text-[0.9375rem] leading-[1.25rem] text-subtitle-text">
            <span className="text-[1rem] font-semibold">
              {t("bonus-page.next_rank_req")}:
            </span>
            <br />
            {isMatchingBonusLoading && (
              <Skeleton className="inline-block align-middle w-30 h-5" />
            )}
            {Boolean(
              progress?.activeDirects?.current ||
                progress?.activeDirects?.required
            ) && (
              <>
                <span>
                  <span className="font-semibold">
                    {t("bonus-page.direct_ref")}:
                  </span>{" "}
                  {progress?.activeDirects?.current}/
                  {progress?.activeDirects?.required};
                </span>
                <br />
              </>
            )}
            {Boolean(
              progress?.activeInFirstNLevels?.current ||
                progress?.activeInFirstNLevels?.required
            ) && (
              <>
                <span>
                  <span className="font-semibold">
                    {t("bonus-page.ten_lines_ref")}:
                  </span>{" "}
                  {progress?.activeInFirstNLevels?.current}/
                  {progress?.activeInFirstNLevels?.required};
                </span>
                <br />
              </>
            )}
            {Boolean(
              progress?.personalVolume?.current ||
                progress?.personalVolume?.required
            ) && (
              <span>
                <span className="font-semibold">
                  {t("bonus-page.personal_volume")}:
                </span>{" "}
                {progress?.personalVolume?.current}/
                {progress?.personalVolume?.required}
              </span>
            )}
          </p>
        </div>
      </div>
    </>
  );
};

export default RankProgress;
